import { z } from '@lucidlink/dto/z';
/**
 * Builds a codec between a compact tuple (`[type, ...values]`, JSON-stringified
 * into the drawer search param) and a keyed params object (used everywhere in
 * code). Field order defines each value's tuple position; optional fields
 * must be last.
 */
export const createDrawerCodec = (type, fields) => {
    const objectSchema = z.object({
        ...Object.fromEntries(fields),
        type: z.literal(type),
    });
    /**
     * The tuple validates each position with its field schema, but zod cannot
     * compute I/O types from an open-ended `[ZodLiteral, ...ZodType[]]` item
     * list, so the tuple type is pinned manually.
     */
    const tupleSchema = z.tuple([
        z.literal(type),
        ...fields.map(([, schema]) => schema),
    ]);
    return z.codec(tupleSchema, objectSchema, {
        decode: ([, ...values]) => Object.fromEntries([
            ['type', type],
            ...fields
                .map(([key], index) => [key, values[index]])
                .filter(([, value]) => value !== undefined),
        ]),
        encode: (params) => {
            const values = fields.map(([key]) => params[key]);
            // JSON.stringify would turn trailing undefined values into null
            while (values.length > 0 && values.at(-1) === undefined) {
                values.pop();
            }
            return [type, ...values];
        },
    });
};
